module.exports = __webpack_public_path__ + "static/img/goldengate.a3f417a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/goldengate.jpg
// module id = m110
// module chunks = 1